import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { getFilePath, getPreviewUrl } from '../../library/utilities/urls.js';
import styles from './file-preview.module.scss';
import Image from './image.jsx';
import ViewAndDownload, { ViewBlob } from './view_download_buttons.jsx';

const getExtension = (path) => path?.split('?')[0].split('.').pop()?.toLowerCase()
const isPreviewable = (path) => {
    const extention = getExtension(path)
    return ['jpg', 'jpeg', 'png', 'svg', 'pdf'].includes(extention)
}
const getFileTypeIcon = (path) => {
    switch (getExtension(path)) {
        case 'csv':
            return "/icons/filetypes/csv.png"
        default:
            return "/icons/filetypes/file.svg"
    }
}
const getBlobPreviewUrl = (file) => {
    if (/image\/[a-z+.-]+/.test(file.type)) {
        return file.preview
    }
    switch (file.type) {
        case "application/pdf":
            return "/icons/filetypes/pdf.svg"
        default:
            return "/icons/filetypes/file.svg"
    }
}

const FilePreview = ({ name, path, fileObj, comment = '', commentLabel, quotationToken }) => {
    const { t } = useTranslation()
    if (!path && !fileObj) {
        return <>ERROR</>
    }
    const getPreview = () => {
        if (fileObj) {
            return <img alt="" src={getBlobPreviewUrl(fileObj)} width={'100px'} height={'100px'} />
        }
        else if (isPreviewable(path)) {
            return <Image src={getPreviewUrl(path, quotationToken)} width={'100px'} height={'100px'} data-file-preview-image />
        }
        return <img alt="" src={getFileTypeIcon(path)} width={'100px'} height={'100px'} data-file-preview-icon />
    }

    return (
        <div className={styles.wrapper}>
            {getPreview()}
            <div className={styles.overflow}>
                <div><b>{t("Name")}</b> : {name}</div>
                {!!comment && (
                    <>
                        <br />
                        <div><b>{commentLabel || t("Comment")}</b> : {comment}</div>
                    </>
                )}
            </div>
            {fileObj ? (
                <ViewBlob obj={fileObj} />
            ) : path && (
                isPreviewable(path) ? (
                    <ViewAndDownload url={path} quotationToken={quotationToken} />
                ) : (
                    <a href={getFilePath(path, quotationToken)} className="button" download>
                        <img src="/icons/download.svg" alt="Download Icon" />
                        {t("Download")}
                    </a>
                )
            )}
        </div>
    )
}


FilePreview.propTypes = {
    name: PropTypes.string.isRequired,
    fileObj: PropTypes.object,
    path: PropTypes.string,
    quotationToken: PropTypes.string.isRequired,
    comment: PropTypes.string,
    commentLabel: PropTypes.string,

}

export { FilePreview };
